import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDs7Q0igZTZC_BawnrmunCGTM7_XoAmI0k',
    libraries: 'places',
  installComponents: true,
},
})
